"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Form_1 = __importDefault(require("../Util/Form"));
const SubmitButton_1 = __importDefault(require("../Input/Base/SubmitButton"));
const helpers_1 = require("../../lib/helpers");
const ContentBg_1 = __importDefault(require("../Layout/ContentBg"));
const A_1 = __importDefault(require("../Util/A"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const TextInput_1 = __importDefault(require("../Input/TextInput"));
const PasswordInput_1 = __importDefault(require("../Input/PasswordInput"));
const LoginPlugin = (props) => {
    const { onSubmit, headerComponent, buttonsComponent, children, forgotPasswordUrl = '/forgot-password', backgroundUrl } = props;
    const [form, setForm] = react_1.useState({
        email: '',
        password: '',
    });
    return (react_1.default.createElement("div", Object.assign({}, helpers_1.usePrimitiveProps(helpers_1.without(props, ['onSubmit']))),
        headerComponent,
        react_1.default.createElement(Form_1.default, { value: form, onChange: setForm },
            react_1.default.createElement(TextInput_1.default, { label: "Email", name: "email", type: "email" }),
            react_1.default.createElement(PasswordInput_1.default, { label: "Password", name: "password" }),
            react_1.default.createElement(SubmitButton_1.default, { className: "w-full h-10 primary my-2 font-bold justify-center", onClick: (e) => onSubmit(form, e) }, "Login"),
            react_1.default.createElement("div", { className: "flex justify-between w-full" },
                react_1.default.createElement(A_1.default, { className: "block", href: forgotPasswordUrl }, "Forgot password?"),
                buttonsComponent)),
        react_1.default.createElement(ContentBg_1.default, { src: backgroundUrl })));
};
exports.default = withJourney_1.default('j-login-plugin', LoginPlugin);
